// src/stone/illustrations/StonjiPercentBlack.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var StonjiPercentBlack = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 64 64",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { fill: "currentcolor", d: "M0 0h64v64H0z" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "currentcolor",
          d: "M52.193 13.804a2 2 0 1 0 0-4 2 2 0 0 0 0 4M11.807 54.196a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "currentcolor",
          d: "M50.79 10.38 10.393 50.779l2.828 2.829 40.398-40.398z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "currentcolor",
          d: "M47.991 35.975a8.02 8.02 0 1 0 0 16.04 8.02 8.02 0 0 0 0-16.04m0 11.988a3.968 3.968 0 1 1-.007-7.936 3.968 3.968 0 0 1 .007 7.936M16.013 12.01a8.02 8.02 0 1 0 0 16.041 8.02 8.02 0 0 0 0-16.042m0 11.987a3.967 3.967 0 1 1 0-7.935 3.967 3.967 0 0 1 0 7.935"
        }
      )
    ]
  }
);
var StonjiPercentBlack_default = StonjiPercentBlack;

export {
  StonjiPercentBlack_default
};
